module.exports = __webpack_public_path__ + "resource/img/logo_aura_eng.32ef6429.svg";